<template>
	<div class="bg-white registration-wrapper EXS-1105">
		<AppLogo />
		<div class="px-3 py-2 flex flex-col h-full w-full overflow-auto">
			<VeeForm
				@invalid-submit="showErrorInput()"
				@submit="registerProcess($event)"
				ref="registerForm"
				method="POST"
				class="app-registration flex flex-col gap-4">
				<div class="font-bold text-2xl py-4 border-b">Erstelle dein expert Konto</div>
				<div class="text-xs">
					Wenn Sie sich anmelden, können Sie den Bezahlprozess schneller durchlaufen, mehrere Lieferadressen speichern und Ihre Daten bei Bedarf
					bequem anpassen.
					<br />
					<br />
					Felder mit einem * müssen ausgefüllt werden
				</div>
				<div class="flex flex-col gap-4 relative">
					<div>
						<div class="grid grid-cols-1 gap-4">
							<div>
								<label class="text-xs py-2 block">Anrede*</label>
								<div>
									<CheckoutVeeFieldOrderInvoiceSalutation @change-salutations="(value) => (salutations = value)" />
								</div>
							</div>
							<div>
								<template v-if="salutations == 'COMPANY'">
									<label class="text-xs py-2 block">Firmenname*</label>
									<div>
										<CheckoutVeeFieldOrderInvoiceCompany />
									</div>
								</template>
							</div>
							<div>
								<label class="text-xs py-2 block">Vorname*</label>
								<CheckoutVeeFieldOrderInvoiceFirstName />
							</div>
							<div>
								<label class="text-xs py-2 block">Nachname*</label>
								<CheckoutVeeFieldOrderInvoiceLastName />
							</div>
						</div>
						<div v-if="addressAutomatic">
							<div class="py-4">Beginnen Sie bei der Adresseingabe mit der Straße</div>
							<div class="font-bold py-4 cursor-pointer" @click="addressAutomatic = false">> Adresse manuell eingeben</div>
						</div>
						<div v-if="!addressAutomatic" class="grid grid-cols-1 lg:grid-cols-3 gap-2">
							<div v-if="false" class="col-span-3 py-4 font-bold cursor-pointer" @click="addressAutomatic = true">
								> Adresseingabe mit Autocomplete
							</div>
							<div class="col-span-2">
								<label class="text-xs py-2 block">Straße*</label>
								<CheckoutVeeFieldOrderInvoiceStreet />
							</div>
							<div class="col-span-2">
								<label class="text-xs py-2 block">Hausnr.*</label>
								<CheckoutVeeFieldOrderInvoiceHouseNumber />
							</div>
							<div class="col-span-2">
								<label class="text-xs py-2 block">PLZ*</label>
								<CheckoutVeeFieldOrderInvoiceZip />
							</div>
							<div class="col-span-2">
								<label class="text-xs py-2 block">Stadt*</label>
								<CheckoutVeeFieldOrderInvoiceCity />
							</div>
							<div class="col-span-2">
								<label class="text-xs py-2 block">Land*</label>
								<CheckoutVeeFieldOrderInvoiceCountry />
							</div>
						</div>
					</div>
					<div class="text-xs w-full overflow-auto" v-html="debug" v-if="useUserGroup()?.value == 'internal'" />
					<div class="text-xs">
						Die Rechnungsadresse muss sich in Deutschland befinden. Für EU-Bestellungen nutzen Sie bitte das Kontaktformular oder kontaktieren Sie
						unseren Kundenservice unter der 0800 0506212 (kostenlos aus dem deutschen Fest- und Mobilfunknetz).
					</div>
					<div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
						<CheckoutPhone :bins="bins" />
					</div>
					<div>
						<label class="text-xs py-2 block">Geburtsdatum</label>
						<VeeField
							name="date"
							v-model="useCartFormData().value.invoiceAddress.date"
							:rules="{ dateRange: ['1900-01-01', getToday()] }"
							v-slot="{ field, meta, errors }">
							<div class="option-included" :class="meta.touched ? (meta.valid ? 'valid' : 'invalid') : ''">
								<!-- 2018-12-31-->
								<input
									v-bind="field"
									class="date-input inp sm w-full"
									type="date"
									min="1900-01-01"
									:max="getToday()"
									placeholder="Geburtsdatum" />
							</div>
							<span>{{ errors[0] }}</span>
						</VeeField>
					</div>
				</div>
				<div>
					<div class="grid grid-cols-1 gap-4">
						<div>
							<label class="text-xs py-2 block">Kundennummer</label>
							<div>
								<input v-model="customerNumber" name="customerNumber" class="inp sm" type="text" placeholder="Kundennummer" />
							</div>
						</div>
						<div>
							<label class="text-xs py-2 block">E-Mail-Adresse*</label>
							<div>
								<CheckoutVeeFieldOrderInvoiceMail />
							</div>
						</div>
						<div>
							<label class="text-xs py-2 block">E-Mail-Adresse wiederholen*</label>
							<div>
								<VeeField
									name="repeatEmail"
									:rules="{
										required: true,
										equal: [useCartFormData().value.invoiceAddress.email, 'E-Mail'],
									}"
									v-model="repeatEmail"
									v-slot="{ field, meta, errors }">
									<div :class="meta.touched ? (meta.valid ? 'valid' : 'invalid') : ''">
										<input v-bind="field" class="inp sm" type="email" placeholder="E-mail wiederholen*" />
									</div>
									<span>{{ errors[0] }}</span>
								</VeeField>
							</div>
						</div>
						<div>
							<label class="text-xs py-2 block">Passwort*</label>
							<div>
								<CheckoutVeeFieldOrderInvoicePassword />
							</div>
						</div>
						<div>
							<label class="text-xs py-2 block">Passwort wiederholen*</label>
							<div>
								<VeeField
									name="passwordRepeat"
									:rules="{
										required: true,
										equal: [`\\${useCartFormData().value.registration.login.password}`, 'Passwort'],
									}"
									v-model="repeatPassword"
									v-slot="{ field, meta, errors }">
									<div :class="meta.touched ? (meta.valid ? 'valid' : 'invalid') : ''">
										<input v-bind="field" class="inp sm" type="password" placeholder="Passwort wiederholen*" />
									</div>
									<span>{{ errors[0] }}</span>
								</VeeField>
							</div>
						</div>
						<div class="text-sm p-3 border border-dashed border-[#8dccea] bg-[#b4e7ff] text-[#0078b1]">
							<CheckoutVeeFieldPasswordRequirementInfo />
						</div>
					</div>
				</div>
				<div class="p-3 border text-xs text-paragraph-light">
					<label class="flex gap-2 items-center">
						<input :name="'newsletter'" type="checkbox" @click="newsletter = !newsletter" />
						<div>Ich möchte den kostenlosen expert Newsletter erhalten und immer über aktuelle Angebote und neueste Technik informiert werden.</div>
					</label>
				</div>
				<CheckoutVeeFieldWarranty :bins="bins" />
				<div class="p-3 border text-sm">
					<CheckoutTerms />
				</div>
				<div :class="captchaError ? 'border border-error' : ''">
					<!-- <NuxtTurnstile
          ref="turnstile"
          v-model="token"
          class="cf-turnstile"
          :options="{ theme: 'light', language: 'de-de' }"
        /> -->
					<div v-if="captchaError" class="captcha-error-message text-error py-2 px-2 text-center border border-error border-dashed bg-error-light">
						{{ result }}
					</div>
				</div>
				<button class="btn-primary font-bold cursor-pointer" type="submit">Registrieren</button>
				<button class="btn-button text-sm" @click="emit('backToLogin')">Zurück</button>
			</VeeForm>
		</div>
	</div>
</template>
<script setup lang="ts">
	import { v4 as uuidv4 } from "uuid";
	import { CHECKOUT_ERRORS } from "../Checkout/Errors";
	import { useCurrentUserState } from "~/composables/states";
	import { getExpUserProfile } from "~/composables/ExpApi/expUser";

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const props = defineProps({
		bins: {
			type: Object,
		},
	});

	const registerForm = ref(null);
	const debug = ref("");
	const repeatEmail = ref("");
	const repeatPassword = ref("");

	const identicalEmail = ref();
	const identicalPassword = ref();
	const newsletter = ref(false);
	const customerNumber = ref("");
	const addressAutomatic = ref(false);
	const salutations = ref("default");
	// const turnstile = ref();
	// const token = ref();
	const captchaError = ref(false);

	watch(repeatEmail, (input) => {
		if (input == registerForm.value.values.email) {
			identicalEmail.value = true;
		} else {
			identicalEmail.value = false;
		}
	});

	watch(repeatPassword, (input) => {
		if (input == registerForm.value.values.password) {
			identicalPassword.value = true;
		} else {
			identicalPassword.value = false;
		}
	});

	if (!useCurrentUserState().value?.defaultAddress) {
		await getExpUserProfile();
	}

	function getToday() {
		const tempDate = new Date();
		return tempDate.getFullYear() + "-" + ("0" + (tempDate.getMonth() + 1)).slice(-2) + "-" + ("0" + (tempDate.getDate() + 1)).slice(-2);
	}

	async function register(csrfToken, registration) {
		console.debug("Function Register - Execute", {
			csrfToken: csrfToken,
			registration: registration,
		});

		return $fetch("/api/user/register", {
			headers: {
				"csrf-token": csrfToken,
				"content-type": "application/json",
			},
			method: "POST",
			credentials: "include",
			body: {
				token: "-_-",
				registration: registration,
			},
		}).catch((error) => {
			return { error: { value: error } };
		});
	}

	function showErrorInput() {
		const firstError = document.body.querySelector(".app-registration .invalid");
		if (import.meta.client) {
			window.scrollTo(0, firstError.offsetTop);
		}
	}

	const result = ref("");
	async function registerProcess(event) {
		captchaError.value = false;
		// if (token.value) {
		// const { status } = await useFetch('/_turnstile/validate', {
		// 	body: {
		// 		token: token.value
		// 	},
		// 	method: 'POST'
		// });
		// token.value = "";
		// if (status.value == "success") {
		if (identicalEmail.value && identicalPassword.value) {
			const id = uuidv4();
			const registration = {
				invoiceAddress: {
					id: id,
					title: event.title,
					firstName: event.firstName,
					lastName: event.lastName,
					street: event.street,
					zip: event.zip,
					city: event.city,
					countryCode: "DE",
					company: event.companyName ? event.companyName : null,
					houseNumber: event.houseNumber,
					date: event.date,
					addition: null,
					email: event.email,
					fax: null,
					mobile: null,
					telephone: event.telephone,
				},
				customerNumber: customerNumber?.value,
				login: {
					email: event.email,
					password: event.password,
				},
				newsletter: newsletter.value,
			};
			console.debug("RegisterProcess - Data Format:", registration);
			const { error } = await register(useCurrentUserState().value?.csrfToken, registration);
			console.debug("RegisterProcess - Response:", toRaw(toValue(error)));

			const errorMessage = getErrorMessage(error);
			if (errorMessage) {
				captchaError.value = true;
				clearNuxtData(["userProfile", "expUserProfile"]);
				result.value = errorMessage;
			} else {
				if (error?.value?.statusCode) {
					result.value = "Ein Fehler ist aufgetreten: " + error?.value?.statusCode;
					captchaError.value = true;
				} else {
					result.value = "Sie wurden erfolgreich registriert.";
					emit("navigateModal", "NONE");
					await navigateTo("/app", {
						external: true,
					});
				}
			}
		}
		// } else {
		// 	turnstile.value.reset()
		// }
		// } else {
		//   turnstile.value.reset();
		//   captchaError.value = true;
		// }
	}

	function getErrorMessage(error) {
		const parsedError = getError(error);
		if (parsedError?.errorcode) return CHECKOUT_ERRORS[parsedError?.namespace + "::" + parsedError?.errorcode];
		return false;
	}

	function getError(error) {
		if (typeof error?.value?.cause?.data == "object" && error?.value?.cause?.data?.errorcode) return error?.value?.cause?.data;
		else if (typeof error?.value?.data == "object" && error?.value?.data?.errorcode) return error?.value?.data;
		else if (typeof error?.value?.data?.data == "object" && error?.value?.data?.data?.errorcode) return error?.value?.data?.data;
		else if (typeof error?.value?.cause?.response?._data == "object") return error?.value?.cause?.response?._data;
		else {
			try {
				return JSON.parse(error?.value?.data);
			} catch {
				return error?.value?.data;
			}
		}
	}

	const emit = defineEmits(["closeRegister", "navigateModal"]);
</script>
<style>
	form input[type="checkbox"] {
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
		background-color: #fff;
		border: 2px solid #ccc;
		border-radius: 2px;
		display: inline-grid;
		height: 15px;
		place-content: center;
		width: 15px;
	}

	form input[type="checkbox"]:checked {
		background-color: rgb(var(--color-primary)) !important;
		border: 2px solid rgb(var(--color-primary)) !important;
	}

	form input[type="checkbox"]:before {
		background-color: #fff;
		clip-path: polygon(13% 50%, 34% 66%, 81% 2%, 100% 18%, 39% 100%, 0 71%);
		content: "";
		height: 10px;
		transform: scale(0);
		transform-origin: bottom left;
		width: 10px;
	}

	form input[type="checkbox"]:checked:before {
		transform: scale(1);
	}

	.invalid + span {
		@apply text-xs text-error;
	}

	.valid + span {
		@apply text-xs text-success;
	}

	.valid {
		position: relative;
		border: 1px solid green;
	}

	.valid:after {
		content: "";
		position: absolute;
		right: 10px;
		width: 1em;
		height: 1em;
		top: 50%;
		pointer-events: none;
		transform: translatey(-50%);
		background-color: green;
		-webkit-mask-repeat: no-repeat;
		mask-repeat: no-repeat;
		-webkit-mask-image: url("~/assets/mediums/Icons/check-regular.svg");
		mask-image: url("~/assets/mediums/Icons/check-regular.svg");
	}

	select {
		@apply appearance-none;
	}

	.date-input {
		appearance: none;
		-webkit-appearance: none;
		-moz-appearance: none;
		min-height: 38px;
	}

	.invalid {
		border: 1px solid red;
		position: relative;
	}

	.invalid:after {
		content: "";
		position: absolute;
		pointer-events: none;
		width: 1em;
		height: 1em;
		top: 50%;
		transform: translatey(-50%);
		right: 10px;
		background-color: red;
		-webkit-mask-repeat: no-repeat;
		mask-repeat: no-repeat;
		-webkit-mask-image: url("~/assets/mediums/Icons/xmark-solid.svg");
		mask-image: url("~/assets/mediums/Icons/xmark-solid.svg");
	}

	.option-included:after,
	.password:after {
		right: 45px;
	}
	.password.invalid:after,
	.password.valid:after {
		right: 45px;
	}
</style>
